import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { RequestDetailModel } from 'src/app/models/request-detail-model';
import { LeaseERODetailsModel, LeaseQuoteModel } from '../quotation-table/quote.model';
import { Subject } from 'rxjs';
import { LeaseQuoteTableComponent } from '../quoteTable/lease-quote-table/lease-quote-table.component';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { Ero } from '../quoteTable/lease-quote-table/lease-quote';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'logzy-ero-add-update',
  templateUrl: './ero-add-update.component.html',
  styleUrls: ['./ero-add-update.component.scss']
})
export class EroAddUpdateComponent implements OnInit {

  @Input() requestDetails: RequestDetailModel;
  eroDataSource;
  displayedColumns: string[] = [];
  quote;
  penaltyTypesOptions;
  disableSave: boolean = false;
  eroList: Ero = null;
  @Output() savedEros = new EventEmitter<void>();
  @Output() closeEroDialog = new EventEmitter<void>();

  fromDays: number = 1;
  toDays: number = 9999;
  amount: number;
  penalty_from: any;
  agreementCurrency: string;
  agreementDays: number;
  type: string = "";
  tempData: Ero = null;
  tempToDays: number;
  tempPenalty: number;
  isCustomer: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LeaseQuoteTableComponent>,
    public requestService: RequestApiService,
    private dialog: MatDialog,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.isCustomer = this.authService.isCustomer();
    this.quote = this.data.quote;
    this.type = this.data.type;
    this.agreementCurrency = this.data.agreementCurrency;
    this.agreementDays = this.data.agreementDays;
    this.penaltyTypesOptions = this.data.penaltyTypesOptions;
    console.log('quote', this.quote);
    this.toDays = this.agreementDays == null ? 9999 : this.agreementDays;
    if (this.quote?.ero?.length != 0) {
      this.eroDataSource = new MatTableDataSource(this.quote.ero);
      this.penalty_from = this.eroDataSource.data[0].penalty_from;
      var count = 1;
      this.eroDataSource.data.map(ero => {
        ero.fromDays = count;
        ero.toDays = ero.fromDays + ero.days;
        count = ero.toDays + 1;
      });
      this.fromDays = this.eroDataSource.data[this.eroDataSource.data.length - 1].toDays + 1;
    } else {
      this.eroDataSource = new MatTableDataSource<null>;
    }

    if (this.isCustomer) {
      this.displayedColumns = ['sequence_no', 'fromDays', 'toDays', 'amount', 'penalty_from'];
    } else {
      this.displayedColumns = ['sequence_no', 'fromDays', 'toDays', 'amount', 'penalty_from', 'actions'];
    }
  }

  add(): void {
    // console.log(this.fromDays, this.toDays);
    if (this.eroDataSource.data.length > 0) {
      if (this.eroDataSource.data[this.eroDataSource.data.length - 1].toDays == this.agreementDays) {
        this.openWarning('Slab limit exceeded', '', 'I Understand');
        return;
      }
    }

    if (this.fromDays > this.toDays) {
      this.openWarning('From-Days cannot be greater than To-Days', '', 'I Understand');
      return;
    }

    if (this.toDays == null) {
      this.openWarning('Please enter To-Days', '', 'I Understand');
      return;
    }

    if (this.amount == null || this.penalty_from == null) {
      this.openWarning('Please enter penalty amount and penalty from', '', 'I Understand');
      return;
    }

    if (this.toDays > this.agreementDays) {
      this.openWarning('Max Value permitted in To-Days is ' + this.agreementDays, '', 'I Understand');
      return;
    }

    if (this.eroDataSource.data.length == 0) {
      if (this.fromDays != 1) {
        this.eroList = new Ero();
        this.eroList.sequence_no = 0;
        this.eroList.fromDays = 1;
        this.eroList.toDays = this.fromDays - 1;
        this.eroList.amount = 0;
        this.eroList.amount_currency = this.agreementCurrency;
        this.eroList.penalty_from = this.penalty_from;
        this.quote.ero.push({ ...this.eroList });
        this.eroList = new Ero();
        this.eroList.sequence_no = this.eroList.sequence_no + 1;
        this.eroList.fromDays = this.fromDays;
        this.eroList.toDays = this.toDays;
        this.eroList.amount = this.amount;
        this.eroList.amount_currency = this.agreementCurrency;
        this.eroList.penalty_from = this.penalty_from;
        this.quote.ero.push({ ...this.eroList });
      } else {
        this.eroList = new Ero();
        this.eroList.sequence_no = this.eroDataSource.data.length + 1;
        this.eroList.fromDays = this.fromDays;
        this.eroList.toDays = this.toDays;
        this.eroList.amount = this.amount;
        this.eroList.amount_currency = this.agreementCurrency;
        this.eroList.penalty_from = this.penalty_from;
        this.quote.ero.push({ ...this.eroList });
      }
    } else {
      this.eroList = new Ero();
      this.eroList.sequence_no = this.eroDataSource.data[this.eroDataSource.data.length - 1].sequence_no + 1;
      this.eroList.fromDays = this.fromDays;
      this.eroList.toDays = this.toDays;
      this.eroList.amount = this.amount;
      this.eroList.amount_currency = this.agreementCurrency;
      this.eroList.penalty_from = this.penalty_from;
      this.quote.ero.push({ ...this.eroList });
    }

    this.eroDataSource.data = this.quote.ero;
    // console.log('this.eroDataSource.data', this.eroDataSource.data);
    this.fromDays = this.eroDataSource.data[this.eroDataSource.data.length - 1].toDays + 1;
    this.toDays = this.agreementDays == null ? 9999 : this.agreementDays;
    this.amount = null;
    this.saveEroDetails();
  }

  saveEroDetails() {
    this.disableSave = true;
    this.eroDataSource.data.map(item => {
      item.days = item.toDays - item.fromDays;
    });
    this.savedEros.emit(this.eroDataSource.data);
    this.disableSave = false;
    // this.dialogRef.close();
  }

  cancelEroDialog() {
    this.closeEroDialog.emit();
    this.dialogRef.close();
  }

  cancelEro(item) {
    item.isEdit = false;
    item.toDays = this.tempToDays;
    item.amount = this.tempPenalty;
  }

  editEro(item) {
    this.tempToDays = item.toDays;
    this.tempPenalty = item.amount;
    item.isEdit = true;
  }

  deleteEro(idx) {
    this.quote.ero.splice(idx, 1);
    this.eroDataSource.data = this.quote.ero;
    if (this.eroDataSource.data.length == 0) {
      this.fromDays = 1;
      this.toDays = this.agreementDays == null ? 9999 : this.agreementDays;
      this.amount = null;
      this.penalty_from = null;
    } else {
      this.fromDays = this.eroDataSource.data[this.eroDataSource.data.length - 1].toDays + 1;
      this.toDays = this.agreementDays == null ? 9999 : this.agreementDays;
      this.amount = null;
    }
    if (this.eroDataSource.data.length == 1) {
      if (this.eroDataSource.data[0].sequence_no == 0) {
        this.quote.ero.splice(0, 1);
        this.fromDays = 1;
        this.toDays = this.agreementDays == null ? 9999 : this.agreementDays;
        this.amount = null;
        this.penalty_from = null;
      }
    }
  }

  saveEro(item) {
    this.eroDataSource.data.map(ero => {
      if (item.sequence_no + 1 == ero.sequence_no) {
        ero.fromDays = item.toDays + 1;
      }
    });
    item.isEdit = false;
  }

  openWarning(label: string, description, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
    });
  }

  isObject = (value: any) => typeof value === 'object';

}
